import React from "react";
import style from "./line.module.scss";

const VerticalLine = () => {
  return <div className={style.vline}></div>;
};

export default VerticalLine;
